import {
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCardContent,
  useIonRouter,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import { CardProps } from "../interfaces/core";
import ThumbnailVideo from "./ThumbnailVideo";

const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  description,
  href,
  src,
  video,
}) => {
  const router = useIonRouter();
  const handleRoute = () => {
    router.push(href);
  };
  const { t } = useTranslation();
  return (
    <IonCard className="card-wrap" onClick={handleRoute} button>
      {video ? (
        <ThumbnailVideo
          {...{ src, ...video }}
          onVideoPlay={(e) => e.stopPropagation()}
        />
      ) : (
        <img src={src} alt={`${t(`${title}.title`)}`} />
      )}
      <IonCardHeader>
        {subtitle && (
          <IonCardSubtitle>{t(`${title}.subtitle`)}</IonCardSubtitle>
        )}
        <IonCardTitle>{t(`${title}.title`)}</IonCardTitle>
      </IonCardHeader>
      <IonCardContent>{t(`${title}.description`)}</IonCardContent>
    </IonCard>
  );
};

export default Card;
